import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActiviteMembreRoutingModule } from './activite-membre-routing.module';
import { ActiviteMembreMainComponent } from './components/activite-membre-main/activite-membre-main.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '../core/core.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { SaisieMembreActiviteComponent } from './components/saisie-membre-activite/saisie-membre-activite.component';
import { AssociationActiviteMembresComponent as AssociationActiviteMembresComponent } from './components/association-activite-membres/association-activite-membres.component';
import { AssociationMembreActivitesComponent } from './components/association-membre-activites/association-membre-activites.component';
import { AssociationMembreActivitesPopupComponent } from './components/association-membre-activites-popup/association-membre-activites-popup.component';
import { AssociationActiviteMembresPopupComponent } from './components/association-activite-membres-popup/association-activite-membres-popup.component';
import { SaisieMembreComponent } from './components/saisie-membre/saisie-membre.component';
import { SaisieActiviteComponent } from './components/saisie-activite/saisie-activite.component';
import { EnteteActionsDirective } from '../layout/directives/entete-zone.directive';
import { FICHE_IMPORTS } from '../core/components/fiche-imports';

@NgModule({
  declarations: [
    ActiviteMembreMainComponent,
    SaisieMembreActiviteComponent,
    AssociationActiviteMembresComponent,
    AssociationMembreActivitesComponent,
    AssociationMembreActivitesPopupComponent,
    AssociationActiviteMembresPopupComponent,
    SaisieMembreComponent,
    SaisieActiviteComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CoreModule,
    NgSelectModule,
    ActiviteMembreRoutingModule,
    EnteteActionsDirective,
    ...FICHE_IMPORTS,
  ],
  exports: [],
})
export class ActiviteMembreModule {}
